// extracted by mini-css-extract-plugin
export var cardWrapper = "_42-0";